(() => {
  const selector = '[data-product-tooltip-title]';
  const tooltip = document.createElement('div');
  tooltip.className = 'or-product-tooltip';
  tooltip.hidden = true;
  tooltip.setAttribute('aria-hidden', 'true');
  const title = document.createElement('span');
  const price = document.createElement('strong');
  tooltip.append(title, price);
  document.body.append(tooltip);
  let active;

  function hide() {
    tooltip.hidden = true;
    active = null;
  }

  function show(link) {
    if (!link) return;
    active = link;
    title.textContent = link.dataset.productTooltipTitle;
    price.textContent = link.dataset.productTooltipPrice;
    tooltip.hidden = false;
    const rect = link.getBoundingClientRect();
    const width = tooltip.offsetWidth;
    const height = tooltip.offsetHeight;
    const left = Math.max(12, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 12));
    const top = rect.top >= height + 20 ? rect.top - height - 10 : rect.bottom + 10;
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${Math.max(12, Math.min(top, window.innerHeight - height - 12))}px`;
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const link = event.target.closest(selector);
    if (link && link !== active) show(link);
  });
  document.addEventListener('pointerout', (event) => {
    if (active && active.contains(event.target) && !active.contains(event.relatedTarget)) hide();
  });
  document.addEventListener('focusin', (event) => show(event.target.closest(selector)));
  document.addEventListener('focusout', hide);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
  });
  window.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);
})();
